// Helper de track sem React (uso fora de componentes, ex: AuthContext).
// Mantém os mesmos campos do hook useAnalytics, fire-and-forget.

import { supabase } from "@/integrations/supabase/client";
import { getSessionId, getDevice, getUtm } from "@/utils/analyticsSession";

export type AnalyticsEventType =
  | "page_view"
  | "whatsapp_click"
  | "plan_view"
  | "checkout_click"
  | "signup_started"
  | "signup_completed"
  | "login"
  | "tool_access"
  | "direct_payment_page_view"
  | "direct_payment_whatsapp_click"
  | "direct_payment_nubank_click"
  | "direct_payment_pix_click"
  | "direct_payment_card_click"
  | "admin_whatsapp_acompanhamento_click"
  | "guru_chat_message_sent"
  | "guru_chat_tool_action"
  | "guru_chat_quota_blocked"
  | "guru_chat_opened"
  | "guru_chat_floating_click"
  | "guru_chat_mode_changed"
  | "guru_chat_quick_action";

export function trackEvent(
  event: AnalyticsEventType,
  metadata?: Record<string, unknown>,
  userId?: string | null
) {
  try {
    const utm = getUtm();
    const payload = {
      event_type: event,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      user_id: userId || null,
      session_id: getSessionId(),
      device: getDevice(),
      referrer: typeof document !== "undefined" ? document.referrer || null : null,
      utm_source: utm.utm_source || null,
      utm_medium: utm.utm_medium || null,
      utm_campaign: utm.utm_campaign || null,
      metadata: metadata || null,
      created_at: new Date().toISOString(),
    };
    // fire-and-forget
    void supabase.from("analytics_events" as any).insert(payload as any).then(
      () => {},
      () => {}
    );
  } catch {
    /* silent */
  }
}
